export function initCalculator() {
  const isHideTerm = detectHideTerm();
  if (isHideTerm) applyHideTermUi();

  $('[data-range]')?.each(function () {
    const $item = $(this);
    const $range = $item.find('.range__input');
    const $thumb = $item.find('.range__thumb');
    const $fill = $item.find('.range__track-fill');
    const $result = $item.find('[data-range-result]');
    const $returnDate = $('[data-return-date]');
    const formatName = $result.data('format') || 'default';
    const formatter = RANGE_FORMATTERS[formatName] || RANGE_FORMATTERS.default;

    if (isHideTerm && formatName === 'days') return;

    function update() {
      const min = Number($range.attr('min'));
      const max = Number($range.attr('max'));
      const value = Number($range.val());
      const percent = (value - min) / (max - min);
      const width = $range.outerWidth();
      const offset = percent * width;

      $range.val(value);
      $thumb.css('left', offset + 'px');
      $fill.css('width', percent * 100 + '%');
      $result?.text(formatter(value, $result));

      // Синхронизация калькуляторов
      $(`[data-range]`)?.each(function () {
        const $otherItem = $(this);
        const $otherRange = $otherItem.find('.range__input');
        const $otherThumb = $otherItem.find('.range__thumb');
        const $otherFill = $otherItem.find('.range__track-fill');
        const $otherResult = $otherItem.find('[data-range-result]');
        const otherFormat = $otherResult.data('format') || 'default';

        if (otherFormat !== formatName || $otherItem.is($item)) return;

        const otherMin = Number($otherRange.attr('min'));
        const otherMax = Number($otherRange.attr('max'));
        const otherPercent = (value - otherMin) / (otherMax - otherMin);
        const otherWidth = $otherRange.outerWidth();
        const otherOffset = otherPercent * otherWidth;

        $otherRange.val(value);
        $otherThumb.css('left', otherOffset + 'px');
        $otherFill.css('width', otherPercent * 100 + '%');
        $otherResult?.text(formatter(value, $otherResult));
      });

      if ($returnDate?.length && formatName === 'days') {
        $returnDate.text(formatReturnDate(value));
      }
    }

    $range.on('input', () => update());
    $(window).on('resize', () => update());
    update();
  });

  updateAmountRangeMax();
  if (!isHideTerm) updateDaysRangeBounds();
  $(document).on('offers:updated', () => {
    updateAmountRangeMax();
    if (!isHideTerm) updateDaysRangeBounds();
  });
  initOfferFilter();
  initCalculatorFixed();
}

function detectHideTerm() {
  try {
    const raw = document.body?.dataset?.template;
    if (!raw) return false;
    const websiteData = JSON.parse(raw);
    return Boolean(websiteData?.hideTerm);
  } catch (_) {
    return false;
  }
}

function applyHideTermUi() {
  $('[data-calculator], [data-calculator-fixed]').addClass('calculator--hide-term');

  $('[data-calculator], [data-calculator-fixed]').each(function () {
    const $calculator = $(this);
    const $daysResult = $calculator.find('[data-range-result][data-format="days"]').first();
    const $daysItem = $daysResult.closest('[data-range]');
    $daysItem.hide();
  });
}

function updateDaysRangeBounds() {
  const bounds = getOfferTermBounds();
  if (!bounds) return;

  const { minDays, maxDays } = bounds;

  $('[data-range-result][data-format="days"]').each(function () {
    const $result = $(this);
    const $item = $result.closest('[data-range]');
    const $range = $item.find('.range__input');

    const valueRaw = Number($range.val());
    const value = Number.isFinite(valueRaw) ? valueRaw : minDays;
    const nextMin = Math.max(1, minDays);
    const nextMax = Math.max(nextMin, maxDays);
    const nextValue = Math.min(nextMax, Math.max(nextMin, value));

    $range.attr('min', String(nextMin));
    $range.attr('max', String(nextMax));
    if (nextValue !== value) $range.val(nextValue);

    // Trigger update to recalculate slider position
    $item.find('.range__input').trigger('input');
  });

  $('[data-calculator], [data-calculator-fixed]').find('[data-range]').each(function () {
    const $item = $(this);
    const $edges = $item.find('.calculator__edges');
    const $result = $item.find('[data-range-result]');
    if ($result.data('format') !== 'days' || !$edges.length) return;

    const $edgeLeft = $edges.find('span').eq(0);
    const $edgeRight = $edges.find('span').eq(1);
    if ($edgeLeft.length) $edgeLeft.text(`${minDays} ${pluralizeRu(minDays, 'день', 'дня', 'дней')}`);
    if ($edgeRight.length) $edgeRight.text(`${maxDays} ${pluralizeRu(maxDays, 'день', 'дня', 'дней')}`);
  });
}

const RANGE_FORMATTERS = {
  money(value, $el) {
    const suffix = $el.data('suffix') || '₽';
    return value.toLocaleString('ru-RU') + ' ' + suffix;
  },

  days(value, $el) {
    const suffix = pluralizeRu(value, 'день', 'дня', 'дней');  
    return value + ' ' + suffix;
  },

  default(value) {
    return value;
  },
};

function pluralizeRu(value, one, few, many) {
  const n = Math.abs(value) % 100;
  const n1 = n % 10;

  if (n > 10 && n < 20) return many;
  if (n1 > 1 && n1 < 5) return few;
  if (n1 === 1) return one;
  return many;
}

function initCalculatorFixed() {
  const $window = $(window);
  const $original = $('[data-calculator]');
  const $fixed = $('[data-calculator-fixed]');

  if (!$original.length || !$fixed.length) return;

  function checkPosition() {
    const scrollTop = $window.scrollTop();
    const windowHeight = $window.height();
    const offsetTop = $original.offset().top;
    const height = $original.outerHeight();
    const isVisible = offsetTop < scrollTop + windowHeight && offsetTop + height > scrollTop;
    const isPassed = scrollTop > offsetTop + height;
    $fixed.toggleClass('active', isPassed && !isVisible);
  }

  $window.on('scroll resize', checkPosition);
  checkPosition();
}

function updateAmountRangeMax() {
  const maxOfferAmount = getMaxOfferAmount();
  if (!maxOfferAmount) return;

  $('[data-range-result][data-format="money"]').each(function () {
    const $result = $(this);
    const $item = $result.closest('[data-range]');
    const $range = $item.find('.range__input');
    const min = Number($range.attr('min')) || 1000;
    const nextMax = Math.max(min, maxOfferAmount);
    const value = Number($range.val()) || min;

    $range.attr('max', String(nextMax));
    if (value > nextMax) $range.val(nextMax);

    // Trigger update to recalculate slider position
    $item.find('.range__input').trigger('input');
  });

  $('[data-calculator], [data-calculator-fixed]').find('[data-range]').each(function () {
    const $item = $(this);
    const $edges = $item.find('.calculator__edges');
    const $result = $item.find('[data-range-result]');
    if ($result.data('format') !== 'money' || !$edges.length) return;

    const $edgeRight = $edges.find('span').eq(1);
    if ($edgeRight.length) {
      $edgeRight.text(maxOfferAmount.toLocaleString('ru-RU') + ' ₽');
    }
  });
}

function initOfferFilter() {
  $(document).on('click', '[data-calculator] .button, [data-calculator-fixed] .button', function (event) {
    const $button = $(this);
    const isFixedButton = $button.closest('[data-calculator-fixed]').length > 0;
    const isMobile = window.innerWidth < 768;

    // Если fixed-кнопка на мобилке — скроллим к основному калькулятору
    if (isFixedButton && isMobile) {
      const mainCalculator = document.querySelector('[data-calculator]');

      if (mainCalculator) {
        const elementPosition = mainCalculator.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.scrollY - 48;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
      }
      return;
    }

    event.preventDefault();

    const $calculator = $button.closest('[data-calculator], [data-calculator-fixed]');
    const amount = getCalculatorValue($calculator, 'money');
    const isHideTerm = $calculator.hasClass('calculator--hide-term');
    const days = isHideTerm ? null : getCalculatorValue($calculator, 'days');

    applyOfferFilter({ amount, days });
    scrollToOffers();
  });
}

function scrollToOffers() {
  const bankiruSection = document.querySelector('[data-bankiru-section]:not([style*="display: none"])');
  const target = bankiruSection || document.querySelector('[data-offers="1"]');
  if (!target) return;

  const offsetPosition = target.getBoundingClientRect().top + window.scrollY - 24;
  window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
}

function getCalculatorValue($calculator, format) {
  const $result = $calculator.find(`[data-range-result][data-format="${format}"]`).first();
  const $item = $result.closest('[data-range]');
  const $range = $item.find('.range__input');
  const value = Number($range.val());
  return Number.isFinite(value) ? value : 0;
}

function applyOfferFilter({ amount, days }) {
  const minAmount = 1000;
  const targetAmount = Math.max(minAmount, Number(amount) || minAmount);
  const termBounds = getOfferTermBounds();
  const minDays = Math.max(1, termBounds?.minDays ?? 1);
  const maxDays = Math.max(minDays, termBounds?.maxDays ?? minDays);
  const targetDays = days == null ? null : Math.min(maxDays, Math.max(minDays, Number(days) || minDays));

  $('[data-offer-amount]').each(function () {
    const el = this;
    if (el.hasAttribute('data-bankiru-offer')) return;

    const offerAmount = Number(el.getAttribute('data-offer-amount')) || 0;
    const termStartRaw = Number(el.getAttribute('data-offer-term-start')) || 0;
    const termEndRaw = Number(el.getAttribute('data-offer-term-end')) || 0;
    const termStart = Math.min(termStartRaw, termEndRaw);
    const termEnd = Math.max(termStartRaw, termEndRaw);

    const matchAmount = offerAmount >= targetAmount;
    const matchTerm = targetDays == null ? true : (termStart <= targetDays && targetDays <= termEnd);
    const isVisible = matchAmount && matchTerm;

    el.style.display = isVisible ? '' : 'none';
  });
}

function getMaxOfferAmount() {
  let max = 0;
  $('[data-offer-amount]').each(function () {
    const value = Number(this.getAttribute('data-offer-amount'));
    if (Number.isFinite(value)) max = Math.max(max, value);
  });
  return max;
}

function getOfferTermBounds() {
  let minDays = Infinity;
  let maxDays = 0;

  $('[data-offer-term-start][data-offer-term-end]').each(function () {
    const start = Number(this.getAttribute('data-offer-term-start'));
    const end = Number(this.getAttribute('data-offer-term-end'));
    if (!Number.isFinite(start) || !Number.isFinite(end)) return;
    if (start > 0) minDays = Math.min(minDays, start);
    if (end > 0) maxDays = Math.max(maxDays, end);
  });

  if (!Number.isFinite(minDays) || !maxDays) return null;
  return { minDays, maxDays };
}

function formatReturnDate(days) {
  const date = new Date();
  date.setDate(date.getDate() + Number(days));

  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const yyyy = date.getFullYear();

  return `${dd}.${mm}.${yyyy}`;
}
